const INVALID_ORIGIN_PHRASE = "Invalid or unrecognized origin domain";

function getExceptionMessages(event) {
  return (event.exception?.values ?? [])
    .map((value) => value?.value)
    .filter((value) => typeof value === "string");
}

function getEventMessages(event) {
  return [event.message, ...getExceptionMessages(event)].filter(
    (value) => typeof value === "string"
  );
}

export function shouldDropSentryEvent(event) {
  return getEventMessages(event).some((message) =>
    message.includes(INVALID_ORIGIN_PHRASE)
  );
}

export function beforeSend(event) {
  if (shouldDropSentryEvent(event)) {
    return null;
  }

  return event;
}
